import Field from './Field';
import ConnectedHeader from './ConnectedHeader';
// Form Layout Components
import Row from './Row';
import GridRow from './GridRow';
import Fieldset from './Fieldset';
import Legend from './Legend';
import HeaderBlock from './HeaderBlock';
import HeaderContainer from './HeaderContainer';
import HeaderTitle from './HeaderTitle';
import HeaderAction from './HeaderAction';
import Form from './Form';
import FormContainer from './FormContainer';
import TabPanel from './TabPanel';
import TabContent from './TabContent';

const FormComponents = {
  Header: ConnectedHeader,
  Field,
  Row,
  GridRow,
  Fieldset,
  HeaderBlock,
  HeaderContainer,
  HeaderTitle,
  HeaderAction,
  Legend,
  Form,
  FormContainer,
  TabContent,
  TabPanel,
};

export default FormComponents;
